import colors from 'vuetify/lib/util/colors';
import { lightenDarkenColor, hexAddAlpha, type Colors } from '../utils/color';

const generateColorOpacity = (colorName: string, hexCode: string, generate: number): Colors => {
  const result: Colors = { };
  Array(generate).fill(null).forEach((_, index: number) => {
    const n = index + 1;
    const key: string = `${colorName}-opacity-${n}`;
    result[key] = hexAddAlpha(hexCode, (100 / (generate + 1)) * n); // or * (generate - n)
  });
  return result;
};

export default {
  // doc: https://vuetifyjs.com/en/features/theme/
  defaultTheme: 'light',
  variations: {
    colors: ['primary', 'error', 'info', 'success', 'warning'],
    lighten: 5,
    darken: 4,
  },
  themes: {
    light: {
      dark: false,
      colors: {
        ...((): object => {
          const hex = colors.teal.lighten1;
          return { ...generateColorOpacity('primary', hex, 10), primary: hex };
        })(),

        ...((): object => {
          const hex = '#B00020';
          return { ...generateColorOpacity('error', hex, 10), error: hex, 'error-lighten-6': lightenDarkenColor(hex, 90) };
        })(),

        ...((): object => {
          const hex = '#2196F3';
          return { ...generateColorOpacity('info', hex, 10), info: hex };
        })(),

        ...((): object => {
          const hex = '#4CAF50';
          return { ...generateColorOpacity('success', hex, 10), success: hex };
        })(),

        ...((): object => {
          const hex = '#FB8C00';
          return { ...generateColorOpacity('warning', hex, 10), warning: hex };
        })(),

        ...((): object => {
          const hex = '#F5F5F5';
          return { ...generateColorOpacity('registered', hex, 10), warning: hex };
        })(),
      },
    },
    // dark: {
    //   dark: true,
    //   colors: {

    //   },
    // },
  },
};
